const STEPS = [
  {
    n: "01",
    title: "Discovery & Scope",
    body:
      "We sit down, walk the site, and listen. We get clear on the goals, the budget, the timeline, and the way you want to live in the space.",
  },
  {
    n: "02",
    title: "Design & Estimate",
    body:
      "Drawings, materials, and a transparent line-item estimate. No vague allowances, no hidden margins — just a real plan you can sign off on.",
  },
  {
    n: "03",
    title: "Build",
    body:
      "Our crews show up clean, on time, and accountable. You get weekly photo updates and a single point of contact from groundbreak to punchlist.",
  },
  {
    n: "04",
    title: "Walk-through & Warranty",
    body:
      "A meticulous walk-through, a workmanship warranty, and a team that picks up the phone after the keys are handed over.",
  },
];

export const Process = () => {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative bg-[#F4F3EF] py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <div className="reveal grid grid-cols-1 lg:grid-cols-12 gap-10 mb-16 lg:mb-20 items-end">
          <div className="lg:col-span-6">
            <div className="text-xs tracking-[0.25em] uppercase font-bold text-[#9E8262]">
              03 — How We Work
            </div>
            <h2 className="font-display font-bold text-[#1A1D1A] mt-5 text-4xl sm:text-5xl lg:text-[56px] leading-[1.04] tracking-tight">
              A calm, transparent
              <br />
              <span className="italic font-light text-[#2C4230]">build process.</span>
            </h2>
          </div>
          <div className="lg:col-span-5 lg:col-start-8">
            <p className="font-body text-[#4A524A] text-base sm:text-lg leading-relaxed">
              Most homeowner horror stories start with a fuzzy contract and a
              ghosted contractor. Ours starts with a real conversation — and ends
              with a finished home you&apos;re proud to show off.
            </p>
          </div>
        </div>

        <ol className="relative grid grid-cols-1 md:grid-cols-2 gap-px bg-[#DCD9CE] border border-[#DCD9CE]">
          {STEPS.map((step, i) => (
            <li
              key={step.n}
              data-testid={`process-step-${step.n}`}
              className="reveal bg-[#F4F3EF] p-8 sm:p-12 hover:bg-[#EBE9E2] transition-colors duration-500"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="flex items-baseline gap-5">
                <span className="font-display font-black text-[#2C4230]/15 text-6xl sm:text-7xl leading-none">
                  {step.n}
                </span>
                <h3 className="font-display font-bold text-[#1A1D1A] text-2xl sm:text-3xl tracking-tight">
                  {step.title}
                </h3>
              </div>
              <p className="font-body text-[#4A524A] mt-6 text-[15px] leading-relaxed max-w-xl">
                {step.body}
              </p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};
